export const fetchAddressFromCoords = async (lat, lng) => {
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
      const response = await fetch(url, {
        headers: { "Accept": "application/json", "User-Agent": "DanelaApp/1.0" }
      });
      if (!response.ok) return null;
      const data = await response.json();
      return data.display_name || null;
    } catch (error) {
      console.error("Gagal mengambil alamat:", error);
      return null;
    }
  };
  